import { mapActions } from "vuex";
import { EventNames } from "../../../../classes/EventNames";
import { AppParameters } from "../../../../AppParameters";

export default {
    data() {
        return {
            graphicsSearchEnabled: AppParameters.graphics_search_enabled
        }
    },
    methods : {
        ...mapActions('GraphicsSearchModule', ['getRelevantGraphics']),
        async getGraphics(search = "") {
            const query = search ? search : this.defaultSearch;
            await this.getRelevantGraphics(query);
        },
    },
    created() {
        if (this.graphicsSearchEnabled) {
            EventBus.listen(EventNames.RELEVANT_GRAPHICS, (search) => {
                this.getGraphics(search);
            });
        }
    }
}
